var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import configSnapshotActions from "../actions/ConfigSnapshotActions.js";
import { createReducer } from "@ane/legacy/lib/decorators/ReduxDecorators";
const initialState = {
  defaultSnapshot: "",
  error: "",
  selectedSnapshot: "",
  selectedMergeMode: "",
  snapshotUpdateStatus: null,
  snapshots: []
};
class ConfigSnapshotReducer {
  getSnapshots(state, action) {
    if (action.error === true) {
      return __spreadProps(__spreadValues({}, state), {
        error: action.payload
      });
    }
    return __spreadProps(__spreadValues({}, state), {
      snapshots: action.payload
    });
  }
  getDefaultSnapshot(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      defaultSnapshot: action.payload,
      selectedSnapshot: action.payload
    });
  }
  getSelectedMergeMode(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      selectedMergeMode: action.payload
    });
  }
  getSnapshotUpdateStatus(state, action) {
    if (action.error === true) {
      return __spreadProps(__spreadValues({}, state), {
        error: action.payload
      });
    }
    return __spreadProps(__spreadValues({}, state), {
      snapshotUpdateStatus: action.payload
    });
  }
  setSection(state, action) {
    if (action.error) {
      return __spreadProps(__spreadValues({}, state), {
        error: action.payload
      });
    }
    return __spreadProps(__spreadValues({}, state), {
      selectedSnapshot: action.payload
    });
  }
  reset(state) {
    return initialState;
  }
  selectSnapshot(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      selectedSnapshot: action.payload
    });
  }
}
const reducer = createReducer(configSnapshotActions, new ConfigSnapshotReducer(), initialState);
export {
  ConfigSnapshotReducer,
  reducer as default
};
//# sourceMappingURL=ConfigSnapshotReducer.js.map
